module.exports = __webpack_public_path__ + "img/akpf.7163c12b.png";